import KlatpensionArticlesPreviews from './KlatpensionArticlesPreviews';

export default KlatpensionArticlesPreviews;
